import DashboardLayout from "@/layout/dashboard/DashboardLayout.vue";
// GeneralViews
const NotFound = () => import("@/pages/System/NotFoundPage.vue");
// Admin pages
import Dashboard from "@/pages/Dashboard.vue";
import OrderCustomer from "@/pages/OrderCustomer/List.vue";
const Login = () => import("@/pages/Login");
import AnonymousOrder from "@/pages/AnonymousOrder/Order.vue";
import TicketReservations from "@/pages/TicketReservations/TicketReservations.vue";
import Location from "@/pages/Location/List.vue";
import Report from "@/pages/Dashboard/Report.vue";
import Notifications from "@/pages/Notifications/Notifications.vue";
const AccessDenied = () => import("@/pages/System/AccessDenied.vue");
const Home = () => import("@/pages/Home.vue");
const appName = " | Petrolimex";

const routes = [
  {
    path: "/login",
    name: "Đăng nhập",
    component: Login,
    meta: {
      auth: false,
      title: "Đăng nhập" + appName,
    },
  },
  {
    path: "/anonymous-order",
    name: "Đơn hàng vãng lai",
    component: AnonymousOrder,
    meta: {
      auth: false,
      title: "Đơn hàng vãng lai" + appName,
    },
  },
  {
    path: "/ticket-reservations",
    name: "Đặt vé trực tuyến",
    component: TicketReservations,
    meta: {
      auth: false,
      title: "Đặt vé trực tuyến" + appName,
    },
  },
  {
    path: "/:catchAll(.*)",
    name: "NotFound",
    component: NotFound,
    meta: {
      requiresAuth: false,
    },
  },
  { path: "/access-denied", component: AccessDenied },
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/report",
    meta: {
      auth: true,
    },
    
    children: [
      {
        path: "home",
        name: "Trang chủ",
        component: Home,
        meta: {
          auth: true,
        },
      },
      {
        path: "report",
        name: "Tổng quan",
        component: Report,
        meta: {
          auth: true,
          title: "Tổng quan" + appName,
        },
      },
      {
        path: "order-customer",
        name: "Đơn hàng",
        component: OrderCustomer,
        meta: {
          auth: true,
          title: "Đơn hàng " + appName,
        },
      },
      {
        path: "dashboard",
        name: "Lịch biểu",
        component: Dashboard,
        meta: {
          auth: true,
          title: "Lịch biểu " + appName,
        },
      },
      {
        path: "location",
        name: "Địa chỉ",
        component: Location,
        meta: {
          auth: true,
          title: "Địa chỉ " + appName,
        },
      },
      
    ],
  },
  
  
];


export default routes;
